module.exports = __webpack_public_path__ + "static/media/apartment8.edf637cc.jpg";